import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
import { Router as RouterConstant } from '@/core/Constants'
import MainContainer from '@components/home/MainContainer.vue'

const ROUTER_BASE_URL = import.meta.env.VITE_BASE_URL

const routes: Array<RouteRecordRaw> = [
  {
    path: `/${RouterConstant.MAIN_APP}`,
    name: RouterConstant.ROUTE_NAME_MAIN_APP_HOME,
    meta: {
      title: '首页',
      keepAlive: true,
      requireAuth: true,
    },
    component: MainContainer,
  },
  {
    path: `/${RouterConstant.MICRO_APP_MAIN}/:path(.*)`,
    name: RouterConstant.ROUTE_NAME_MICRO_APP_MAIN,
    meta: {
      title: '微应用首页',
      keepAlive: true,
      requireAuth: true,
    },
    component: MainContainer,
  },
  {
    path: `/${RouterConstant.MICRO_APP_PREVIEW_BASE}/:path(.*)`,
    name: RouterConstant.ROUTE_NAME_MICRO_APP_PREVIEW,
    meta: {
      title: '新窗口',
      keepAlive: true,
      requireAuth: true,
    },
    component: () => import('@components/preview/PreviewWindow.vue'),
  },
  {
    path: '/:path(.*)',
    redirect: {
      name: RouterConstant.ROUTE_NAME_MAIN_APP_HOME,
    },
  },
]

const router = createRouter({
  history: createWebHistory(ROUTER_BASE_URL),
  routes,
})

export default router
